import { useEffect } from 'react'
import useSWR from 'swr'

import fetcher from '../../lib/fetcher'

export type WorkingHours = {
  day: string
  availability: Availability[]
}

export interface Availability {
  startTime: number
  endTime: number
}

export interface Clinician {
  id: number
  firstName: string
  lastName: string
  phone?: string
  professionTitle?: string
  specialtyAndSubSpecialtyTitle?: string
  categories?: string[]
  biography?: string
  qualifications?: string
  competences?: string
  profilePictureUrl?: string
  workingHours?: WorkingHours[]
}

export function useClinician(clinicianId?: number): { clinician?: Clinician; error: unknown; isLoading: boolean } {
  const { data, error } = useSWR<Clinician>(clinicianId ? `/clinicians/${clinicianId}` : null, fetcher.api)

  useEffect(() => {
    if (error) {
      console.error('🔴 Error getting clinician data', { error })
    }
  }, [error])

  return { clinician: data, error, isLoading: clinicianId ? !error && !data : false }
}
